<template>
  <div class="dateSingleOrRangeKPI">
    <RadioTop :options="['本月', '上月', '自訂區間']" :defaultValue="type" @input="typeChange($event)" @same="same"/>
    <div class="pop" v-show="show">
      <DateInput :style="{height: '40px', width: '400px'}"  v-if="show"
      :defaultValue="range" @input="range=$event"/>
    </div>
  </div>
</template>

<script>
import DateInput from '../input/dateRange.vue'
import RadioTop from '../radio/r1.vue'

export default {
  props: ['defaultValue'],
  name: 'dateSingleOrRangeKPI',
  components: {
    RadioTop,
    DateInput
  },
  data () {
    return {
      type: '今日',
      show: false,
      range: {
        start: this.moment().format('yyyy-MM-DD'),
        duration: 0,
        end: this.moment().format('yyyy-MM-DD')
      }
    }
  },
  watch: {
    defaultValue: {
      handler () {
        const thisMonth = this.moment().startOf('month').format('yyyy-MM-DD')
        const lastMonth = this.moment().add(-1, 'month').startOf('month').format('yyyy-MM-DD')
        const d0 = this.moment(thisMonth).endOf('month').diff(this.moment(thisMonth), 'day')
        const d = this.moment(lastMonth).endOf('month').diff(this.moment(lastMonth), 'day')
        if (this.defaultValue.start === thisMonth && this.defaultValue.duration === d0) {
          this.type = '本月'
          this.range.start = thisMonth
          this.range.duration = d0
          this.range.end = this.moment(thisMonth).endOf('month').format('yyyy-MM-DD')
        } else if (this.defaultValue.start === lastMonth && this.defaultValue.duration === d) {
          this.type = '上月'
          this.range.start = lastMonth
          this.range.duration = d
          this.range.end = this.moment(lastMonth).endOf('month').format('yyyy-MM-DD')
        } else {
          this.type = '自訂區間'
          this.range.start = this.defaultValue.start
          this.range.duration = this.defaultValue.duration
          this.range.end = this.defaultValue.end
        }
        console.log(this.type)
      },
      immediate: true,
      deep: true
    },
    range: {
      handler () {
        if (this.range.start && this.range.end) {
          this.range.duration = this.moment(this.range.end).diff(this.moment(this.range.start), 'day')
          this.show = false
          if (this.type === '自訂區間') {
            this.$emit('input', this.range)
          }
        }
      },
      deep: true
    }
  },
  methods: {
    typeChange (ev) {
      if (ev === '本月') {
        this.type = '本月'
        const thisMonth = this.moment().startOf('month').format('yyyy-MM-DD')
        const d = this.moment(thisMonth).endOf('month').diff(this.moment(thisMonth), 'day')
        this.range = {
          start: thisMonth,
          duration: d,
          end: this.moment(thisMonth).endOf('month').format('yyyy-MM-DD')
        }
        this.show = false
        this.$emit('input', this.range)
      } else if (ev === '上月') {
        this.type = '上月'
        const lastMonth = this.moment().add(-1, 'month').startOf('month').format('yyyy-MM-DD')
        const d = this.moment(lastMonth).endOf('month').diff(this.moment(lastMonth), 'day')
        this.range = {
          start: lastMonth,
          duration: d,
          end: this.moment(lastMonth).endOf('month').format('yyyy-MM-DD')
        }
        this.show = false
        this.$emit('input', this.range)
      } else if (ev === '自訂區間') {
        this.type = '自訂區間'
        this.show = true
      }
    },
    same (ev) {
      console.log('same', ev)
      if (ev === '自訂區間') {
        this.show = true
        this.show1 = false
      }
      if (ev === '自訂日期') {
        this.show1 = true
        this.show = false
      }
    }
  }
}
</script>
<style lang="scss">
.dateSingleOrRangeKPI {
  input[type=radio] {
    min-width: 110px;
  }
#setDate-wrapper #setDate-input {
  border-color: #C4C4C4;
}
  #setDateRange-wrapper #setDateRange-input {
    height: 40px;
    letter-spacing: 0;
  }
}
</style>
<style lang="scss" scoped>
.dateSingleOrRangeKPI {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 14px;
  position: relative;
}
.pop {
  position: absolute;
  top: 42px;
  height: 60px;
  right: 5px;
  padding: 10px;
  background: #FFFFFF;
  box-shadow: 4px 0px 4px rgba(0, 0, 0, 0.25), -2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  display: flex;
  align-items: center;
  &.pop1 {
    left: 155px;
    width: 300px;
  }
}
</style>
